<template>
  <v-list-item dense two-line @click.stop="click">
    <v-list-item-action>
      <slot name="prepend-action" :on="{ click: clickAction }"></slot>
    </v-list-item-action>

    <v-list-item-content>
      <vs-text truncate :title="title">{{ title }}</vs-text>
      <vs-text v-if="subTitle" truncate type="subdued" :title="subTitle">{{ subTitle }}</vs-text>
    </v-list-item-content>
    <v-list-item-action v-if="count > 0"
      ><span class="disclosure"
        >{{ count }} <v-icon>mdi-chevron-right</v-icon></span
      ></v-list-item-action
    >
  </v-list-item>
</template>

<script setup lang="ts">
interface Props {
  id?: number | string
  title: string
  subTitle?: string | null
  count?: number
}

const props = withDefaults(defineProps<Props>(), {
  id: null,
  subTitle: null,
  count: 0,
})

const emit = defineEmits(['select', 'expand'])

const clickAction = (e) => {
  e.stopPropagation()
  emit('select', props.id)
}

const click = () => {
  if (props.count > 0) {
    emit('expand', props.id)
  } else {
    emit('select', props.id)
  }
}
</script>

<style scoped>
.disclosure {
  display: inline-flex;
}
</style>
